import { useMemo } from 'react';

import useInitCloudflare from './useInitCloudflare';

const useCdnDomains = () => {
	const { zones: cdnZones, ...rest } = useInitCloudflare();

	const cdnDomains = useMemo(() => {
		const record: Record<string, string> = {};

		cdnZones.forEach((zone) => {
			if (zone.name && zone.uniq_id) {
				record[zone.name] = zone.uniq_id;
			}
		});

		return record;
	}, [cdnZones]);

	return { cdnDomains, ...rest };
};

export default useCdnDomains;
